import { IconButtonGroup } from "components/Form";
import { AbilityContext } from "components/Permissions/Can";
import React, { useCallback, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { ReactComponent as PlusDisabledIcon } from 'assets/icons/PlusDisabled.svg';
import { assessmentRQ } from "store/hooks";
import { TestTakerVM } from "models/VM";
import { useDispatch } from "react-redux";
import { actions } from "store";
import { alerts, features } from "keys";
import { EditButtonStyles } from '../Style'
import { IconButton, SvgIcon } from "@mui/material";
import { tableHooks } from "components/Table";
import { isEmpty, join, map } from "lodash";
import { XSSpaceBetween } from "styles/GlobalStyle";
import { submit } from "redux-form";
import { validate } from "pages/School/CreateTestTaker";
import AvatarCell from "../AvatarCell";
import { permissions } from "config/ability";

export const useEditTestTakerCell = () => {
    const dispatch = useDispatch()

    const updateOrCreateTestTaker = useCallback((test_taker) => {
        dispatch(actions.setAlerts(
            {
                key: alerts.createTestTaker,
                value: {
                    open: true, props: {
                        ...test_taker,
                        language: test_taker?.language?.id
                    }
                }
            }))
    }, [])

    return {
        accessorKey: 'edit',
        header: "עריכה",
        enableSorting: false,
        // permissions: [
        //     {
        //         feature: "test_taker",
        //         role: "write",
        //     },
        //     {
        //         feature: features.school_setup,
        //         role: permissions.read
        //     },
        //     {
        //         feature: features.school_setup,
        //         role: permissions.write
        //     }
        // ],
        feature: features.school_setup,
        role: permissions.read,
        cell: ({ row }) => {
            const data = row.original
            const errors = validate(data)
            const isValid = isEmpty(errors)

            return (
                <EditButtonStyles>
                    <IconButton
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            //השימוש היחיד כרגע בממשק בתי ספר - מצבת תלמידים - עריכת תלמיד שחסר לו פרטים - invalid מיועד לשורות שיש להם שדה 
                            if (data.invalid)
                                updateOrCreateTestTaker(data);
                            else {
                                const testTaker = new TestTakerVM(data);
                                updateOrCreateTestTaker(testTaker)
                            }
                        }}
                    >
                        <SvgIcon className={!isValid && "invalid-icon"} component={EditIcon} inheritViewBox />
                        {!isValid &&
                            <React.Fragment>
                                <XSSpaceBetween />
                                <div className={`invalid-label`}>
                                    {!isValid && "הצג נתונים חסרים"}
                                </div>
                            </React.Fragment>
                        }
                    </IconButton>
                </EditButtonStyles>
            );
        }
    }
}


const useColumns = () => {
    const ability = useContext(AbilityContext)
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const testTakerNameCell = tableHooks.useTestTakerNameCell()
    const idCell = tableHooks.useIdCell()
    const editTestTakerCell = useEditTestTakerCell()

    const { pathname } = useLocation()

    const student = ability.can("read", "student-label") ? "תלמיד" : "ילד"

    const { mutateAsync: bulkCreateByLevel, isPending: bulkCreateByLevelLoading } = assessmentRQ.useBulkCreateByLevel()


    const columns = useMemo(
        () => [
            {
                ...idCell,
                accessorKey: "test_taker_id"
            },
            {
                accessorKey: 'img',
                width: 30,
                header: "",
                cell: AvatarCell,
                meta: {
                    label: "פרופיל"
                }
            },
            testTakerNameCell,
            {
                accessorKey: 'tz',
                header: "תעודת זהות",
            },
            {
                accessorKey: 'affiliation_name',
                header: "בית ספר",
                showBrokenDisplay: true
            },
            {
                accessorKey: 'grade_at_registration_name',
                header: "שכבה בעת ההרשמה",
            },
            {
                accessorKey: 'grade_name',
                header: "שכבה נכחית",
            },
            {
                accessorKey: 'school_class_name',
                header: "כיתה",
            },
            {
                accessorKey: 'language',
                header: "שפה עיקרית בבית",
                cell: (info) => info.getValue()?.label
            },
            // {
            //     accessorKey: 'new_assessment',
            //     header: "התאמת מבדק",
            //     alignCenter: true,
            //     enableSorting: false,
            //     cell: ({ row }) => {
            //         const { last_assessment, test_taker_id } = row.original;

            //         return (
            //             <IconButtonGroup
            //                 color="thirdly4"
            //                 tooltip={last_assessment ? "התאימו לי מבדק נוסף" : "התאימו לי מבדק"}
            //                 selected={!last_assessment}
            //                 icon={last_assessment ? PlusDisabledIcon : GoIcon}
            //                 disabled={last_assessment}
            //                 action={async () => {
            //                     await bulkCreateByLevel(test_taker_id);
            //                     if (pathname !== app.dashboard)
            //                         navigate(app.performAssessments);
            //                 }}
            //             />
            //         );
            //     }
            // },
            editTestTakerCell
        ], []
    )

    return columns
}


export default useColumns